export default __webpack_public_path__ + "static/media/admin_search_icon.075e55a3.svg";